<template>
  <div>
    <b-modal
      id="modal_dont_print"
      centered
      hide-footer
      hide-header-close
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      no-stacking
      title-class="text-center w-100"
      title="ATENÇÃO"
      class="bg-sysblue"
      body-class="bg-sysblue"
    >
      <b-row no-gutters align-h="center" class="bg-sysblue text-white">
        <b-col cols="auto">
          <template>
            <div class="text-center">
              <h4 class="m-0">OPS!</h4>
              <p class="worksansr mt-0">NÃO PODE TIRAR PRINT DO SISTEMA</p>
              <i class="fas fa-exclamation-triangle fa-2x"></i>
            </div>
            <div class="text-center mt-3">
              <v-btn @click="$bvModal.hide('dont_print')" class="v-danger"
                >OK</v-btn
              >
            </div>
          </template>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="popupAuthBySessionExpired"
      size="md"
      no-close-on-backdrop
      hide-footer
      hide-header-close
      centered
      hide-header
    >
      <form @submit.prevent="handleAuthBySessionExpired">
        <h6 class="alert alert-warning check-text-center">
          Sua sessão expirou por inatividade, por favor realize o login
          novamente ou clique em sair.
        </h6>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <label>Informe o e-mail</label>
            <input
              class="form-control"
              autofocus
              type="email"
              v-model="email_signin"
              autocomplete="off"
              placeholder="e-mail"
            />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <label>Informe a senha</label>
            <b-input-password v-model="password_signin" placeholder="Senha" />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <ErrorsMessages :errors="errors" />
          </div>

          <div
            class="
              col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
              d-flex
              align-items-center
            "
          >
            <v-btn @click="handleGoToAuth" block class="btn-exit">SAIR</v-btn>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <v-btn
              type="submit"
              :disabled="loadingAuthBySessionExpired"
              block
              class="btn-acess btn-block"
            >
              <i class="fas fa-sign-in-alt mr-2 text-twenty"></i>
              {{ loadingAuthBySessionExpired ? "Carregando" : "ACESSAR" }}
            </v-btn>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<style>
#popupAuthBySessionExpired .text-session {
  font-size: 16px;
  font-weight: 500;
  text-align: justify;
  background-color: #fbeddd !important;
  padding: 10px 20px;
  color: #fb8c00 !important;
}
</style>

<script>
import ErrorsMessages from "./ErrorsMessages";

import api from "../../services/api";

import routes from "../../routes";
import BInputPassword from "./BInputPassword.vue";
import { set } from "idb-keyval";

export default {
  name: "AuthBySessionExpired",
  components: {
    ErrorsMessages,
    BInputPassword,
  },
  props: {
    popupAuthBySessionExpired: Boolean,
  },
  data() {
    return {
      loadingAuthBySessionExpired: false,
      email_signin: "",
      password_signin: "",
      errors: [],
    };
  },
  onIdle() {
    let accessed_offline = JSON.parse(
      sessionStorage.getItem("accessed_offline") || !this.$store.state.online
    );
    if (accessed_offline) {
      routes.push({ name: "sign-in" });
    } else {
      this.$bvModal.show("popupAuthBySessionExpired");
    }
  },
  methods: {
    async handleAuthBySessionExpired() {
      try {
        this.loadingAuthBySessionExpired = true;

        const rest_home_id = JSON.parse(sessionStorage.getItem("rest_home_id"));

        if (!rest_home_id) {
          return routes.push({ name: "sign-in" });
        }

        const { email_signin: email, password_signin: password } = this;

        const response = await api.post("/rest-home/user/auth", {
          rest_home_id,
          email,
          password,
        });

        const { error, errors, user, permissions, system_update } =
          response.data;

        if (!error) {
          await set("user", user);
          sessionStorage.setItem("rest_home_id", user.rest_home_id);
          sessionStorage.setItem("rest_home_name", user.rest_home_name);
          sessionStorage.setItem("user", JSON.stringify(user));
          sessionStorage.setItem("permissions", JSON.stringify(permissions));
          sessionStorage.setItem("uid", user.id);

          this.email_signin = "";
          this.password_signin = "";
          this.$bvModal.hide("popupAuthBySessionExpired");

          if (system_update && system_update.status == 1) {
            sessionStorage.setItem(
              "system_update",
              JSON.stringify(system_update)
            );
          } else {
            sessionStorage.removeItem("system_update");
          }

          location.reload();
        } else {
          this.errors = errors;
        }

        this.loadingAuthBySessionExpired = false;
      } catch (error) {
        console.log(error);
      }
    },
    async handleGoToAuth() {
      try {
        sessionStorage.removeItem("accessed_offline");
        localStorage.removeItem("residents_cached");
        await api.get("/status/logout");
      } catch {
        //nada
      }

      routes.push({ name: "sign-in" });
    },
  },
};
</script>
